import createIcon from './createIcon';

export default createIcon(require('./car.svg'));